module.exports = __webpack_public_path__ + "img/p4.30870198.jpg";